import React from 'react';
import { styled } from '@linaria/react';

import Demo, { DemoSliderControl } from '@/components/Demo';

function HueVsHueRotateDemo() {
  return (
    <Demo
      outputWrapper={null}
      customGrid={{
        gridTemplateColumns: 'min(400px, 100%)',
        justifyContent: 'center',
      }}
      initialValues={{
        hueRotate: 0,
      }}
      controls={[
        <DemoSliderControl
          key="hueRotate"
          id="hueRotate"
          label="Target hue"
          min={0}
          max={360}
          previewRenderer={(val) => `${val}deg`}
        />,
      ]}
    >
      {({ hueRotate }) => {
        return (
          <Ruler>
            <Wrapper>
              <Column>
                <Label>background-color:</Label>
                <HueBox style={{ '--hue': hueRotate + 'deg' }}>
                  hsl({hueRotate}deg 100% 80%)
                </HueBox>
              </Column>
              <Column>
                <Label>filter:</Label>
                <FilterBox style={{ '--hue': hueRotate + 'deg' }}>
                  hue-rotate({hueRotate}deg)
                </FilterBox>
              </Column>
            </Wrapper>
          </Ruler>
        );
      }}
    </Demo>
  );
}

const Ruler = styled.div`
  container-type: inline-size;
`;

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 1rem;

  @container (max-width: 36.5rem) {
    flex-direction: column;
    align-items: center;
  }
`;

const Column = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  width: 100%;
  max-width: 30rem;
`;

const Label = styled.div`
  font-size: 1rem;
  font-family: var(--font-family-mono);
  color: var(--color-text);
  text-align: center;
`;

const Box = styled.div`
  width: 100%;
  padding: 1rem;
  border-radius: 8px;
  text-align: center;
  color: black;
  font-weight: var(--font-weight-bold);
  font-family: var(--font-family-mono);
  background-color: hsl(0deg 100% 80%);
  font-size: 1rem;
`;

const HueBox = styled(Box)`
  background-color: hsl(var(--hue) 100% 80%);
`;

const FilterBox = styled(Box)`
  filter: hue-rotate(var(--hue));
`;

export default HueVsHueRotateDemo;
